import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Terms = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Terms & Conditions',
      lastUpdated: 'Last Updated: January 2025',
      sections: [
        {
          title: '1. Introduction and Acceptance',
          content: 'These Terms and Conditions govern your use of the ARIA MEA Ventures website and services. By accessing or using our website, you agree to be bound by these Terms and all applicable laws and regulations of the United Arab Emirates. If you do not agree with any part of these terms, you must not use our website or services. ARIA MEA Ventures is registered and operates in accordance with the laws of the United Arab Emirates, specifically in Ras Al Khaimah.'
        },
        {
          title: '2. Company Information',
          content: 'ARIA MEA Ventures operates as a trading and distribution company in the United Arab Emirates. Registered Address: FDAM0223, Compass Building, Al Shohada Road, Ras Al Khaimah, United Arab Emirates. Contact Email: contact@ariamea.com. All business activities are conducted in compliance with UAE Federal Law No. 18 of 1993 concerning Commercial Transactions Law and subsequent amendments.'
        },
        {
          title: '3. Services Offered',
          content: 'ARIA MEA Ventures provides international trading, distribution, sourcing, and business consulting services across the Middle East, Asia, Europe, and Africa. Services include but are not limited to: market expansion support, cross-border sourcing and trading, logistics and supply chain coordination, and business development. All services are provided in accordance with UAE commercial laws and international trade regulations. Service availability and terms are subject to individual agreements and may vary based on specific client requirements.'
        },
        {
          title: '4. Use of Website',
          content: 'You are granted a limited, non-exclusive, non-transferable license to access and use this website for lawful business purposes only. You agree not to: (a) use the website for any unlawful purpose or in violation of UAE laws; (b) attempt to gain unauthorized access to our systems; (c) interfere with the proper functioning of the website; (d) reproduce, duplicate, or copy material from the website without prior written consent; (e) use the website to transmit any harmful or malicious code. We reserve the right to terminate access for violation of these terms.'
        },
        {
          title: '5. Intellectual Property Rights',
          content: 'All content on this website, including text, graphics, logos, images, and software, is the property of ARIA MEA Ventures or its content suppliers and is protected by UAE intellectual property laws and international copyright treaties. The ARIA MEA trademark and logo are registered marks. Unauthorized use of any content may violate copyright, trademark, and other applicable laws and could result in criminal or civil penalties under UAE law.'
        },
        {
          title: '6. Privacy and Data Protection',
          content: 'We are committed to protecting your privacy in accordance with UAE Federal Law and applicable data protection regulations. Personal information collected through this website is handled in compliance with UAE privacy laws. We collect only necessary business information and do not share your data with third parties without consent, except as required by UAE law or regulatory authorities. For detailed information, please refer to our Privacy Policy. Users have the right to access, correct, or delete their personal information as per UAE regulations.'
        },
        {
          title: '7. Electronic Communications',
          content: 'In accordance with UAE Federal Law No. 1 of 2006 concerning Electronic Transactions and Commerce, by using this website and providing your contact information, you consent to receive electronic communications from ARIA MEA Ventures. These communications may include notices about your account, transactional information, and promotional materials. Electronic records and signatures have the same legal effect as paper documents under UAE law.'
        },
        {
          title: '8. Pricing and Payment Terms',
          content: 'All prices quoted are subject to confirmation and may vary based on market conditions, currency fluctuations, and other factors. Prices are typically quoted in USD, EUR, or AED unless otherwise specified. Payment terms are established in individual service agreements. Late payments may incur charges as permitted under UAE Commercial Law. All transactions are subject to applicable UAE taxes and duties. We reserve the right to modify prices and payment terms with reasonable notice.'
        },
        {
          title: '9. Limitation of Liability',
          content: 'To the maximum extent permitted by UAE law, ARIA MEA Ventures shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or services. Our total liability for any claims shall not exceed the amount paid by you for the specific service giving rise to the claim. This limitation applies to all causes of action, whether based on contract, tort, negligence, strict liability, or otherwise. Nothing in these terms shall exclude or limit liability for death or personal injury caused by negligence, fraud, or any liability that cannot be excluded under UAE law.'
        },
        {
          title: '10. Force Majeure',
          content: 'ARIA MEA Ventures shall not be liable for any failure or delay in performance due to circumstances beyond our reasonable control, including but not limited to: acts of God, natural disasters, wars, terrorism, civil unrest, government actions, pandemics, strikes, transportation delays, or failures of third-party service providers. In such events, our obligations shall be suspended for the duration of the force majeure circumstance, as recognized under UAE Commercial Law.'
        },
        {
          title: '11. Dispute Resolution',
          content: 'Any disputes arising from these Terms or use of our services shall first be attempted to be resolved through good faith negotiations between the parties. If negotiations fail, disputes shall be resolved through arbitration in accordance with the UAE Arbitration Law (Federal Law No. 6 of 2018) and the rules of the Dubai International Arbitration Centre (DIAC) or ADCCAC (Abu Dhabi Commercial Conciliation and Arbitration Centre). The place of arbitration shall be Dubai or Abu Dhabi, UAE. The language of arbitration shall be English. The arbitrator\'s decision shall be final and binding.'
        },
        {
          title: '12. Governing Law and Jurisdiction',
          content: 'These Terms and Conditions shall be governed by and construed in accordance with the laws of the United Arab Emirates, specifically UAE Federal Laws and the laws of the Emirate of Ras Al Khaimah. Any matters not subject to arbitration shall fall under the exclusive jurisdiction of the courts of Ras Al Khaimah, UAE. If any provision of these terms is found to be unenforceable under UAE law, that provision shall be modified to reflect the parties\' intention or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.'
        },
        {
          title: '13. Changes to Terms',
          content: 'ARIA MEA Ventures reserves the right to modify these Terms and Conditions at any time in accordance with UAE law. Changes will be effective immediately upon posting on this website. Your continued use of the website after changes are posted constitutes acceptance of the modified terms. Material changes will be notified through prominent notice on our website or via email to registered users. We recommend reviewing these terms periodically.'
        },
        {
          title: '14. Severability',
          content: 'If any provision of these Terms is held to be invalid, illegal, or unenforceable under UAE law, the validity, legality, and enforceability of the remaining provisions shall not be affected or impaired. The invalid provision shall be replaced with a valid provision that most closely approximates the intent and economic effect of the invalid provision.'
        },
        {
          title: '15. Language',
          content: 'These Terms and Conditions are provided in English, Arabic, and Romanian for convenience. In accordance with UAE legal requirements, the Arabic version shall prevail in case of any discrepancy or dispute regarding interpretation. All legal notices and communications will be provided in both English and Arabic as required by UAE law.'
        },
        {
          title: '16. Contact Information',
          content: 'For questions, complaints, or concerns regarding these Terms and Conditions, or to exercise your rights under UAE law, please contact us at: ARIA MEA Ventures, FDAM0223, Compass Building, Al Shohada Road, Ras Al Khaimah, United Arab Emirates. Email: contact@ariamea.com. We are committed to responding to all inquiries within 5 business days as required by UAE consumer protection guidelines.'
        }
      ]
    },
    ro: {
      title: 'Termeni și Condiții',
      lastUpdated: 'Ultima actualizare: Ianuarie 2025',
      sections: [
        {
          title: '1. Acceptarea Termenilor',
          content: 'Accesând și utilizând site-ul ARIA MEA Ventures, acceptați și sunteți de acord să fiți legat de termenii și prevederile acestui acord. Dacă nu sunteți de acord cu cele de mai sus, vă rugăm să nu utilizați acest serviciu.'
        },
        {
          title: '2. Licență de Utilizare',
          content: 'Este acordată permisiunea de a accesa temporar materialele (informații sau software) de pe site-ul ARIA MEA Ventures doar pentru vizualizare personală, necomercială și tranzitorie. Aceasta este acordarea unei licențe, nu un transfer de titlu.'
        },
        {
          title: '3. Servicii',
          content: 'ARIA MEA Ventures oferă servicii de trading internațional, distribuție și consultanță. Toate serviciile sunt supuse disponibilității și ne rezervăm dreptul de a modifica sau întrerupe serviciile în orice moment fără preaviz.'
        },
        {
          title: '4. Acuratețea Informațiilor',
          content: 'Deși ne străduim să oferim informații exacte și actualizate despre serviciile și produsele noastre, nu oferim garanții sau declarații cu privire la acuratețea sau completitudinea oricăror informații de pe acest site.'
        },
        {
          title: '5. Limitarea Răspunderii',
          content: 'ARIA MEA Ventures nu va fi răspunzătoare pentru niciun prejudiciu rezultat din utilizarea sau imposibilitatea de a utiliza serviciile noastre, inclusiv, dar fără a se limita la, daune directe, indirecte, incidentale, punitive și consecvente.'
        },
        {
          title: '6. Legea Aplicabilă',
          content: 'Acești termeni și condiții sunt guvernați și interpretați în conformitate cu legile Emiratelor Arabe Unite, iar dumneavoastră vă supuneți irevocabil jurisdicției exclusive a instanțelor din acea locație.'
        },
        {
          title: '7. Informații de Contact',
          content: 'Pentru orice întrebări cu privire la acești termeni și condiții, vă rugăm să ne contactați la contact@ariamea.com'
        }
      ]
    },
    ar: {
      title: 'الشروط والأحكام',
      lastUpdated: 'آخر تحديث: يناير 2025',
      sections: [
        {
          title: '1. الموافقة على الشروط',
          content: 'من خلال الوصول إلى موقع ARIA MEA Ventures واستخدامه، فإنك تقبل وتوافق على الالتزام بشروط وأحكام هذا الاتفاق. إذا كنت لا توافق على الالتزام بما سبق، يرجى عدم استخدام هذه الخدمة.'
        },
        {
          title: '2. ترخيص الاستخدام',
          content: 'يتم منح الإذن للوصول مؤقتًا إلى المواد (المعلومات أو البرامج) على موقع ARIA MEA Ventures للعرض الشخصي وغير التجاري والعابر فقط. هذا هو منح ترخيص، وليس نقل ملكية.'
        },
        {
          title: '3. الخدمات',
          content: 'تقدم ARIA MEA Ventures خدمات التجارة الدولية والتوزيع والاستشارات. جميع الخدمات تخضع للتوافر ونحتفظ بالحق في تعديل أو إيقاف الخدمات في أي وقت دون إشعار.'
        },
        {
          title: '4. دقة المعلومات',
          content: 'بينما نسعى جاهدين لتقديم معلومات دقيقة ومحدثة حول خدماتنا ومنتجاتنا، لا نقدم أي ضمانات أو تمثيلات فيما يتعلق بدقة أو اكتمال أي معلومات على هذا الموقع.'
        },
        {
          title: '5. تحديد المسؤولية',
          content: 'لن تكون ARIA MEA Ventures مسؤولة عن أي أضرار ناشئة عن استخدام أو عدم القدرة على استخدام خدماتنا، بما في ذلك على سبيل المثال لا الحصر، الأضرار المباشرة وغير المباشرة والعرضية والعقابية والتبعية.'
        },
        {
          title: '6. القانون الحاكم',
          content: 'تخضع هذه الشروط والأحكام وتفسر وفقًا لقوانين الإمارات العربية المتحدة، وأنت تخضع بشكل لا رجعة فيه للاختصاص القضائي الحصري للمحاكم في ذلك الموقع.'
        },
        {
          title: '7. معلومات الاتصال',
          content: 'لأي أسئلة بخصوص هذه الشروط والأحكام، يرجى الاتصال بنا على contact@ariamea.com'
        }
      ]
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <div className="min-h-screen pt-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 className="text-4xl md:text-5xl font-bold text-[#003840] mb-4">
          {currentContent.title}
        </h1>
        <p className="text-gray-500 mb-12">{currentContent.lastUpdated}</p>

        <div className="space-y-8">
          {currentContent.sections.map((section, index) => (
            <div key={index} className="pb-6 border-b border-gray-200 last:border-0">
              <h2 className="text-2xl font-semibold text-[#003840] mb-4">
                {section.title}
              </h2>
              <p className="text-gray-600 leading-relaxed">
                {section.content}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-[#F4F7F6] rounded-lg">
          <p className="text-gray-700">
            <strong>ARIA MEA Ventures</strong>
            <br />
            FDAM0223, Compass Building, Al Shohada Road
            <br />
            Ras Al Khaimah, United Arab Emirates
            <br />
            <a href="mailto:contact@ariamea.com" className="text-[#007369] hover:text-[#005A5B]">
              contact@ariamea.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
